//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ScrollableContainer from "@Shared/components/general/scrollable-container";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SettingsNavigation",
  components: {
    ScrollableContainer
  },
  props: {
    tabs: {
      type: Array,
      required: true
    },
    currentTab: {
      type: String,
      default: ""
    },
    settingsKey: {
      type: String,
      required: true
    }
  },
  methods: {
    handleTabChange({
      key,
      disabled
    }) {
      if (disabled) return;
      this.$emit("tab-change", key);
    },
    settingsLink({
      key
    }) {
      return {
        path: `/${this.settingsKey}/${key}`,
        props: {
          tab: key
        }
      };
    }
  }
});